// https://formatjs.io/docs/polyfills
// These polyfills must be in this particular order

// We don't require polyfills in our testing environment, though we should add
// coverage at some point to ensure browsers which _do_ are indeed loading them
/* istanbul ignore if */
if (!Intl.getCanonicalLocales) {
  import('@formatjs/intl-getcanonicallocales/polyfill');
}

if (!Intl.Locale) {
  import('@formatjs/intl-locale/polyfill');
}

if (!Intl.PluralRules) {
  import('@formatjs/intl-pluralrules/polyfill');
  import('@formatjs/intl-pluralrules/locale-data/ar.js');
  import('@formatjs/intl-pluralrules/locale-data/be.js');
  import('@formatjs/intl-pluralrules/locale-data/bg.js');
  import('@formatjs/intl-pluralrules/locale-data/bs.js');
  import('@formatjs/intl-pluralrules/locale-data/cs.js');
  import('@formatjs/intl-pluralrules/locale-data/da.js');
  import('@formatjs/intl-pluralrules/locale-data/de.js');
  import('@formatjs/intl-pluralrules/locale-data/el.js');
  import('@formatjs/intl-pluralrules/locale-data/en.js');
  import('@formatjs/intl-pluralrules/locale-data/es.js');
  import('@formatjs/intl-pluralrules/locale-data/fi.js');
  import('@formatjs/intl-pluralrules/locale-data/fr.js');
  import('@formatjs/intl-pluralrules/locale-data/he.js');
  import('@formatjs/intl-pluralrules/locale-data/hi.js');
  import('@formatjs/intl-pluralrules/locale-data/hr.js');
  import('@formatjs/intl-pluralrules/locale-data/hu.js');
  import('@formatjs/intl-pluralrules/locale-data/is.js');
  import('@formatjs/intl-pluralrules/locale-data/it.js');
  import('@formatjs/intl-pluralrules/locale-data/ja.js');
  import('@formatjs/intl-pluralrules/locale-data/ka.js');
  import('@formatjs/intl-pluralrules/locale-data/lb.js');
  import('@formatjs/intl-pluralrules/locale-data/mk.js');
  import('@formatjs/intl-pluralrules/locale-data/ml.js');
  import('@formatjs/intl-pluralrules/locale-data/nl.js');
  import('@formatjs/intl-pluralrules/locale-data/no.js');
  import('@formatjs/intl-pluralrules/locale-data/pl.js');
  import('@formatjs/intl-pluralrules/locale-data/pt.js');
  import('@formatjs/intl-pluralrules/locale-data/ro.js');
  import('@formatjs/intl-pluralrules/locale-data/ru.js');
  import('@formatjs/intl-pluralrules/locale-data/sk.js');
  import('@formatjs/intl-pluralrules/locale-data/sl.js');
  import('@formatjs/intl-pluralrules/locale-data/sv.js');
  import('@formatjs/intl-pluralrules/locale-data/tl.js');
  import('@formatjs/intl-pluralrules/locale-data/uk.js');
}

if (!Intl.NumberFormat) {
  import('@formatjs/intl-numberformat/polyfill');
  import('@formatjs/intl-numberformat/locale-data/ar.js');
  import('@formatjs/intl-numberformat/locale-data/be.js');
  import('@formatjs/intl-numberformat/locale-data/bg.js');
  import('@formatjs/intl-numberformat/locale-data/bs.js');
  import('@formatjs/intl-numberformat/locale-data/cs.js');
  import('@formatjs/intl-numberformat/locale-data/da.js');
  import('@formatjs/intl-numberformat/locale-data/de.js');
  import('@formatjs/intl-numberformat/locale-data/el.js');
  import('@formatjs/intl-numberformat/locale-data/en.js');
  import('@formatjs/intl-numberformat/locale-data/es.js');
  import('@formatjs/intl-numberformat/locale-data/fi.js');
  import('@formatjs/intl-numberformat/locale-data/fr.js');
  import('@formatjs/intl-numberformat/locale-data/he.js');
  import('@formatjs/intl-numberformat/locale-data/hi.js');
  import('@formatjs/intl-numberformat/locale-data/hr.js');
  import('@formatjs/intl-numberformat/locale-data/hu.js');
  import('@formatjs/intl-numberformat/locale-data/is.js');
  import('@formatjs/intl-numberformat/locale-data/it.js');
  import('@formatjs/intl-numberformat/locale-data/ja.js');
  import('@formatjs/intl-numberformat/locale-data/ka.js');
  import('@formatjs/intl-numberformat/locale-data/lb.js');
  import('@formatjs/intl-numberformat/locale-data/mk.js');
  import('@formatjs/intl-numberformat/locale-data/ml.js');
  import('@formatjs/intl-numberformat/locale-data/nl.js');
  import('@formatjs/intl-numberformat/locale-data/no.js');
  import('@formatjs/intl-numberformat/locale-data/pl.js');
  import('@formatjs/intl-numberformat/locale-data/pt.js');
  import('@formatjs/intl-numberformat/locale-data/ro.js');
  import('@formatjs/intl-numberformat/locale-data/ru.js');
  import('@formatjs/intl-numberformat/locale-data/sk.js');
  import('@formatjs/intl-numberformat/locale-data/sl.js');
  import('@formatjs/intl-numberformat/locale-data/sv.js');
  import('@formatjs/intl-numberformat/locale-data/uk.js');
}

if (!Intl.RelativeTimeFormat) {
  import('@formatjs/intl-relativetimeformat/polyfill');
  import('@formatjs/intl-relativetimeformat/locale-data/ar.js');
  import('@formatjs/intl-relativetimeformat/locale-data/be.js');
  import('@formatjs/intl-relativetimeformat/locale-data/bg.js');
  import('@formatjs/intl-relativetimeformat/locale-data/bs.js');
  import('@formatjs/intl-relativetimeformat/locale-data/cs.js');
  import('@formatjs/intl-relativetimeformat/locale-data/da.js');
  import('@formatjs/intl-relativetimeformat/locale-data/de.js');
  import('@formatjs/intl-relativetimeformat/locale-data/el.js');
  import('@formatjs/intl-relativetimeformat/locale-data/en.js');
  import('@formatjs/intl-relativetimeformat/locale-data/es.js');
  import('@formatjs/intl-relativetimeformat/locale-data/fi.js');
  import('@formatjs/intl-relativetimeformat/locale-data/fr.js');
  import('@formatjs/intl-relativetimeformat/locale-data/he.js');
  import('@formatjs/intl-relativetimeformat/locale-data/hi.js');
  import('@formatjs/intl-relativetimeformat/locale-data/hr.js');
  import('@formatjs/intl-relativetimeformat/locale-data/hu.js');
  import('@formatjs/intl-relativetimeformat/locale-data/is.js');
  import('@formatjs/intl-relativetimeformat/locale-data/it.js');
  import('@formatjs/intl-relativetimeformat/locale-data/ja.js');
  import('@formatjs/intl-relativetimeformat/locale-data/ka.js');
  import('@formatjs/intl-relativetimeformat/locale-data/lb.js');
  import('@formatjs/intl-relativetimeformat/locale-data/mk.js');
  import('@formatjs/intl-relativetimeformat/locale-data/ml.js');
  import('@formatjs/intl-relativetimeformat/locale-data/nl.js');
  import('@formatjs/intl-relativetimeformat/locale-data/no.js');
  import('@formatjs/intl-relativetimeformat/locale-data/pl.js');
  import('@formatjs/intl-relativetimeformat/locale-data/pt.js');
  import('@formatjs/intl-relativetimeformat/locale-data/ro.js');
  import('@formatjs/intl-relativetimeformat/locale-data/ru.js');
  import('@formatjs/intl-relativetimeformat/locale-data/sk.js');
  import('@formatjs/intl-relativetimeformat/locale-data/sl.js');
  import('@formatjs/intl-relativetimeformat/locale-data/sv.js');
  import('@formatjs/intl-relativetimeformat/locale-data/uk.js');
}
